import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PreciosService } from '@precios/precios.service';
import { Cliente } from '@shared/models/cliente/Cliente';

@Component({
  selector: 'app-alijes-saldos',
  templateUrl: './alijes-saldos.component.html',
  styleUrls: ['./alijes-saldos.component.scss']
})
export class AlijesSaldosComponent {

  clienteSeleccionado : Cliente;
  clienteBuscado:string;    

  busquedaFormControl = new UntypedFormControl();

  constructor(
    private precioService: PreciosService
  ) { }

  usuarioSeleccionoCliente(cliente: Cliente) {
    this.clienteSeleccionado = cliente;
  }

  filtrarClientes() {
    this.clienteBuscado = this.busqueda.value;
  }

  get busqueda() {
    return this.busquedaFormControl;
  }  
}
